import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from 'ThreeTerminal_base/publicMethod';
import styles from './index.css';

class SlideArea extends React.PureComponent {
    static propTypes = {
        slideData: PropTypes.object,
    };

    render() {
        const slideData = this.props.slideData || {};
        let { image = [] } = slideData;

        if (Object.prototype.toString.call(image) !== '[object Array]') {
            image = [];
        }

        return image.map((item, index) => (
            <p key={`slide_${index}`} className={styles.textLine}>
                {item.url ? <img src={formatImage(item.url, item.width, item.height)} alt="" /> : null}
                <br />
                {item.description}
            </p>
        ));
    }
}

export default errorBoundary(SlideArea);
